<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field v-if="loginActiv"
            v-model="item.login"
            :error-messages="loginErrors"
            :label="$t('administration.user.login')"
            required
            @input="$v.item.login.$touch()"
            @blur="$v.item.login.$touch()"
          />
          <v-text-field v-else
            v-model="item.login"
            :error-messages="loginErrors"
            :label="$t('administration.user.login')"
            required
            disabled
            @input="$v.item.login.$touch()"
            @blur="$v.item.login.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.email"
            :error-messages="emailErrors"
            :label="$t('administration.user.email')"
            required
            @input="$v.item.email.$touch()"
            @blur="$v.item.email.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.firstname"
            :error-messages="firstnameErrors"
            :label="$t('administration.user.firstname')"
            required
            @input="$v.item.firstname.$touch()"
            @blur="$v.item.firstname.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.lastname"
            :error-messages="lastnameErrors"
            :label="$t('administration.user.lastname')"
            required
            @input="$v.item.lastname.$touch()"
            @blur="$v.item.lastname.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="profilSelectItems"
            v-model="item.profil"
            :items="profilSelectItems"
            :error-messages="profilErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('administration.profil.profil')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('administration.user.enabled') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.enabled"
                :error-messages="enabledErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="profilInterfaceSelectItems"
            v-model="item.profilInterface"
            :items="profilInterfaceSelectItems"
            :error-messages="profilInterfaceErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('administration.profil.profilinterface')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('administration.user.supervision') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.supervision"
                :error-messages="supervisionErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'UserForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    loginActiv: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.profilGetSelectItems();
    this.profilInterfaceGetSelectItems();
  },
  data() {
    return {
        login: null,
        email: null,
        firstname: null,
        lastname: null,
        profil: null,
        enabled: null,
        profilInterface: null,
        supervision: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_profil || this.isLoading_profilInterface
       );
    },
    ...mapFields('profil', {
      profilSelectItems: 'selectItems',
      isLoading_profil : 'isLoading'
    }),
    ...mapFields('profilinterface', {
      profilInterfaceSelectItems: 'selectItems',
      isLoading_profilInterface : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    loginErrors() {
      const errors = [];

      if (!this.$v.item.login.$dirty) return errors;

      has(this.violations, 'login') && errors.push(this.violations.login);

      !this.$v.item.login.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    emailErrors() {
      const errors = [];

      if (!this.$v.item.email.$dirty) return errors;

      has(this.violations, 'email') && errors.push(this.violations.email);

      !this.$v.item.email.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    firstnameErrors() {
      const errors = [];

      if (!this.$v.item.firstname.$dirty) return errors;

      has(this.violations, 'firstname') && errors.push(this.violations.firstname);

      !this.$v.item.firstname.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    lastnameErrors() {
      const errors = [];

      if (!this.$v.item.lastname.$dirty) return errors;

      has(this.violations, 'lastname') && errors.push(this.violations.lastname);

      !this.$v.item.lastname.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    profilErrors() {
      const errors = [];

      if (!this.$v.item.profil.$dirty) return errors;

      has(this.violations, 'profil') && errors.push(this.violations.profil);


      return errors;
    },
    enabledErrors() {
      const errors = [];

      if (!this.$v.item.enabled.$dirty) return errors;

      has(this.violations, 'enabled') && errors.push(this.violations.enabled);


      return errors;
    },
    profilInterfaceErrors() {
      const errors = [];

      if (!this.$v.item.profilInterface.$dirty) return errors;

      has(this.violations, 'profilInterface') && errors.push(this.violations.profilInterface);


      return errors;
    },
    supervisionErrors() {
      const errors = [];

      if (!this.$v.item.supervision.$dirty) return errors;

      has(this.violations, 'supervision') && errors.push(this.violations.supervision);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      profilGetSelectItems: 'profil/fetchSelectItems',
      profilInterfaceGetSelectItems: 'profilinterface/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      login: {
        required,
      },
      email: {
        required,
      },
      firstname: {
        required,
      },
      lastname: {
        required,
      },
      enabled: {

      },
      profil: {
        required,
      },
      profilInterface: {
        required,
      },
      supervision: {
      },
    }
  }
};
</script>
